<template>
  <div>
    <div id="automatic-gift-cards" class="f-h f-sb">
      <div class="f-v">
        <div class="t-xl bold m-b">
          Automatic Gift Cards
        </div>
      </div>
      <div v-if="upgradeRequired" class="f-ac m-bx2">
        <donut-button
          class="inv"
          :show-upgrade-badge="true"
          @click="openUpgradeModal"
        >
          Upgrade to Enable
        </donut-button>
      </div>
      <div v-else class="f-ac m-bx2">
        <p class="t m-rx2">Enable automatic gift cards</p>
        <div @click.prevent="toggleGiftCards">
          <donut-input-toggle
            v-model="giftCardsEnabled"
            :is-disabled="state.formSubmitted"
          />
        </div>
      </div>
    </div>
    <div class="t m-bx2">
      Automatic gift cards can be redeemed by users and fulfilled automatically
      by Donut. There are over 2,000 options in 232+ countries.
    </div>
    <div class="m-b lattice">
      <div :class="[{ 'o-50 pe-n': !giftCardsEnabled }]">
        <shoutouts-rewards-listing
          :dollars-per-point="dollarsPerPoint"
          :points-config="pointsConfig"
          :listing="displayListing"
          :preset="displayListingIsPreset"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const { state, dispatch } = useStore();

const props = defineProps({
  dollarsPerPoint: { type: Number, required: true },
  pointsConfig: { type: Object, required: true },
  giftCardListing: { type: Object, required: false, default: null },
});

const giftCardsEnabled = computed(() => {
  const activeListing = state.rewardsListings.listings.find(
    listing => listing.is_gift_card && listing.state === 'active',
  );
  return !!activeListing;
});

const giftCardStatus = computed(() => state.rewardsListings.giftCardStatus);

const upgradeRequired = computed(() => giftCardStatus.value === 'upgrade_required');

const toggleGiftCards = () => {
  dispatch('rewardsListings/toggleGiftCards', {
    value: !giftCardsEnabled.value,
    pointsConfig: props.pointsConfig,
    dollarsPerPoint: props.dollarsPerPoint,
  });
};

const openUpgradeModal = () => {
  dispatch('openChannelProgramsPlanUpgradeModal', {
    data: {
      title: 'Upgrade to enable gift card rewards',
      source: 'gift_cards',
      defaultPremiumPlan: false,
      allowPlanSelection: true,
      featureInfo: { programKey: 'shoutouts' },
    },
  });
};

const displayListingIsPreset = computed(() => !props.giftCardListing);

const displayListing = computed(() => {
  if (props.giftCardListing) {
    return props.giftCardListing;
  }

  return state.rewardsListings.listingPresets.find(
    preset => preset.is_gift_card === true,
  );
});
</script>
